<script>
import LinkedIn from "@/components/illustrations/LinkedIn";
import Twitter from "@/components/illustrations/Twitter";
import Medium from "@/components/illustrations/Medium";
import Mail from "@/components/illustrations/Mail";

export default {
  name: "Footer",
  components: {
    LinkedIn,
    Twitter,
    Medium,
    Mail
  }
};
</script>

<template>
  <footer class="flex items-center justify-center flex-col">
    <h1>Let's Work Together!</h1>
    <p class="text-center">
      If you want to chat more about anything work or UX related, reach out any
      of the methods below.
    </p>
    <div class="social-icons-container flex justify-center">
      <a href="https://www.linkedin.com/in/k-mai-ho/" target="_blank"
        ><linked-in
      /></a>
      <a href="https://twitter.com/iammaiho" target="_blank"><twitter /></a>
      <a href="https://medium.com/@iammaiho16" target="_blank"><medium /></a>
      <a href="mailto:contact@iammaiho.com" target="_blank"><mail /></a>
    </div>
  </footer>
</template>

<style lang="scss">
footer {
  background-color: var(--dark-purple);
  color: white;
  height: 520px;
  margin-top: 50px;

  h1 {
    font-family: Lora;
    font-style: normal;
    font-size: 64px;
    font-weight: bold;
    line-height: 102%;
  }

  p {
    margin-top: 40px;
    font-family: Open Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 150.2%;
    max-width: 650px;
  }

  .social-icons-container {
    margin-top: 40px;

    a {
      margin-left: 20px;
      margin-right: 20px;
    }
  }
}
</style>
